import ReferenceQuote from "../../../../docs/components/ReferenceQuote.tsx";
import * as React from 'react';
export default {
  ReferenceQuote,
  React
};